import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
export default class extends Controller {
  static targets = ["form", "pageInput"]

  connect() {
  }

  submitForm(event) {
    event.preventDefault()
    console.log('test')
    const page = event.currentTarget.dataset.page
    const url = new URL(window.location.href)
    url.searchParams.set("page", page)
    Turbo.visit(url.toString())
  }
}